export const GET_SCENARIOS = 'GET_SCENARIOS';
